import TerritoryModule from "@/pages/super-admin/components/TerritoryModule";

export default function SuperAdminRegionsPage() {
  return <TerritoryModule level="region" />;
}